<template>
  <div class="procedure_page" v-html="htmlContent"></div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { getGoodsInstruction } from "jhm_api_ts";

@Component({})
export default class Procedure extends Vue {
  htmlContent = "";
  ins_id = (this.$route.query.ins_id || "") + "";

  async mounted() {
    let { info: data } = await getGoodsInstruction({
      ins_id: this.ins_id,
    });
    this.htmlContent = data.contents;
  }
}
</script>

<style lang="scss" scoped>
.procedure_page {
  padding: 10px;

  ::v-deep img {
    width: 100%;
  }
}
</style>
